import { ParsedAddress } from './types';

export const parseAddressComponents = (
  addressComponents: any[]
): ParsedAddress => {
  if (!addressComponents?.length) {
    return {};
  }

  let addressLine1: string | undefined;
  let city: string | undefined;
  let province: string | undefined;
  let postalCode: string | undefined;

  addressComponents.forEach((component: any) => {
    const types = component.types;

    if (types.includes('street_number')) {
      addressLine1 = component.long_name;
    }

    if (types.includes('route')) {
      addressLine1 = addressLine1
        ? `${addressLine1}, ${component.long_name}`
        : component.long_name;
    }

    if (
      types.includes('neighborhood') ||
      types.includes('sublocality_level_2') ||
      types.includes('sublocality_level_1')
    ) {
      addressLine1 = addressLine1
        ? `${addressLine1}, ${component.long_name}`
        : component.long_name;
    }

    if (types.includes('locality')) {
      city = component.long_name;
    }

    if (types.includes('administrative_area_level_1')) {
      province = component.long_name;
    }

    if (types.includes('postal_code')) {
      postalCode = component.long_name;
    }
  });

  return {
    addressLine1,
    city,
    province,
    postalCode,
  };
};